@if (src) {
  @switch (type) {
    @case ('pdf') {
      @if (pdfSrc) {
        <!-- pdfSrc is always a fresh same-origin blob: URL, so the viewer's
        file= param cannot be tampered to point elsewhere; its built-in
        urlValidation only ever false-positives across reloads. Keep it off. -->
        <ng2-pdfjs-viewer
          [pdfSrc]="pdfSrc"
          [locale]="locale"
          [urlValidation]="false"
        />
      }
    }
    @case ('img') {
      <img [src]="src | safeUrl" />
    }
    @default {
      <h3>{{ 'embed.noPreview' | translate: { ext: extension } }}</h3>
    }
  }
}
